import MembershipsNavigation, {
  MembershipsNavigationComponent,
} from './MembershipsNavigation';

export { MembershipsNavigationComponent };
export default MembershipsNavigation;
